import React from "react";
import Lottie from "lottie-react";
import { Container } from "react-bootstrap";

import recycling from "../../../../assets/images/recycling.json";
import leaf from "../../../../assets/images/leaf.png";

import "./HeroSection.scss";

const HeroSection = () => {
  return (
    <div className="hero">
      <Container>
        <div className="text">
          <h1 className="headline">
            Lets make Portugal <br />A better place!
          </h1>
          <p>
            Join us in our mission to promote recycling and create a sustainable
            future for Portugal. Together, we can make a positive impact on the
            environment. Sort your waste, reduce your carbon footprint, and
            contribute to a greener world.
          </p>
          <button className="btn-main">
            <a href="#donate">Donate</a>
          </button>
        </div>
        <div className="anim">
          <Lottie animationData={recycling} />
        </div>
      </Container>
      <img src={leaf} alt="leaf-1" className="leaf one" />
      <img src={leaf} alt="leaf-2" className="leaf two" />
    </div>
  );
};

export default HeroSection;
